import { memo, useEffect } from 'react';
import { Logger } from '@zmedia/bm-soccer-ui/utils';
import { Element, RouterLink } from '@zmedia/bm-soccer-ui/components';
import styles from './style.module.scss';

interface IProps {
    error?: number;
}

export function Content404({ error }: IProps) {
    useEffect(() => {
        Logger.error(404, 'Error_404: ', error);
    }, []);

    return (
        <Element className={styles['error-page']}>
            <Element className={styles['error__content']}>
                <Element className={styles['page-404']}>
                    Không tìm thấy địa chỉ bạn vừa yêu cầu truy cập.
                    <br />
                    <br />
                    Nếu bạn chắc chắn rằng đã đánh đúng địa chỉ, việc hiện ra
                    trang này là lỗi của chúng tôi, hãy bắt đầu từ
                    <RouterLink
                        to="https://baomoi.com"
                        className={styles['link']}
                        title="Trang chủ"
                    >
                        &nbsp;Trang chủ&nbsp;
                    </RouterLink>
                </Element>
            </Element>
        </Element>
    );
}

export default memo(Content404);
